import React from "react";
import { Box, Typography, TextField } from "@mui/material";

interface JoiningReasonStepProps {
    value: string;
    onChange: (value: string) => void;
    error?: string;
}

const JoiningReasonStep: React.FC<JoiningReasonStepProps> = ({ value, onChange, error }) => {
    const MAX_LENGTH = 500;
    return (
        <Box>
            <Typography variant="h6" gutterBottom align="center">
                Why are you joining MAX Aspire?
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom align="center">
                Your input will be used to review your application.
            </Typography>
            <TextField
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                // placeholder="e.g., I'm looking for mentorship, hoping to find job opportunities in the tech industry, or wanting to connect with other Muslim professionals in my city."
                inputProps={{ maxLength: MAX_LENGTH }}
                error={!!error}
                helperText={error || `${value.length}/${MAX_LENGTH} characters`}
            />
        </Box>
    );
};

export default JoiningReasonStep;
